export const orderRouteDef = [
    {
        path: 'add-appointment',
        component: 'AddAppointmentComponent',
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: ':id/:resource/appointment-reschedule',
        component: 'AddAppointmentComponent',
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: ':id/:resource/appointment-direct-reschedule',
        component: 'AddAppointmentComponent',
        data: {
            selector: 'app-add-appointment'
        }
    },
    {
        path: 'care-plan',
        component: 'CarePlanComponent',
        data: {
            selector: 'app-care-plan'
        }
    },
    {
        path: ':resource/viewPrescription',
        component: 'ViewPrescriptionComponent',
        data: {
            selector: 'app-view-prescription',
        }
    },
    {
        path: ':id/:resource/review',
        component: 'ReviewOrderModalComponent',
        data: {
            selector: 'kx-review-order-modal'
        }
    },
    {
        path: 'payment_status',
        component: 'PaymentStatusComponent',
        data: {
            selector: 'kx-payment-status'
        }
    },
    {
        path: ':resource/orderList',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            // resource: 'service_request_history',
            // application: 'order',
            // action: 'LIST',
            action: "LIST",
            decorator: "my_orders_format",
            resource: "my_orders_format",
        }
    },
    {
        path: ':resource/citizenOrderList',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            decorator: "my_orders_format",
            resource: "citizen_orders_format",
        }
    },
    {
        path: 'csp_orders_format/list',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "csp_orders_format",
        }
    },
    {
        path: 'doctor_csp_order_format/list',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "doctor_csp_order_format",
        }
    },
    {
        path: 'appointment_csp_order/list',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "appointment_csp_order",
        }
    },
    {
        path: 'diagnostic_csp_order/list',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "diagnostic_csp_order",
        }
    },
    {
        path: 'medicine_csp_order/list',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "medicine_csp_order",
        }
    },
    {
        path: 'phc_csp_order/list',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            action: "LIST",
            resource: "phc_csp_order",
        }
    },
    {
        path: ':id/:resource/queue',
        component: 'PatientViewQueueComponent',
        data: {
            selector: 'kx-patient-view-queue'
        }
    },
    {
        path: ':id/:resource/queue',
        component: 'PatientViewQueueComponent',
        data: {
            selector: 'kx-patient-view-queue'
        }
    },
    {
        path: ':resource/EDIT_GRID',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            action: 'EDIT_GRID',
            "resource": "immunization_details"
        }
    },
    {
        path: ':resource/OUTSIDE_EDIT_GRID',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            action: 'EDIT_GRID',
            "resource": "outside_administration_immunization"
        }
    },

    {
        path: 'diagnostic_csp_order/upload_report',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'upload_csp_diagnostic_report',
            action: 'ADD'
        }
    },
    {
        path: 'diagnostic_csp_order/view_report',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: "upload_csp_diagnostic_report",
            action: 'IMAGE_VIEWER'
        }
    },
    {
        path: 'citizen_csp_diagnostic_report/view_report',
        component: 'CommonViewerComponent',
        data: {
            selector: 'app-common-viewer',
            resource: "citizen_csp_diagnostic_report",
            action: 'IMAGE_VIEWER'
        }
    }
]


